import React, { useState, useEffect } from "react";
import { Eye, Trash2, Plus, RotateCcw, FileText, Briefcase } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./RegistrationStyles.css";

const url = process.env.REACT_APP_BACKEND_URL;

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);
  const navigate = useNavigate();

  const fetchCustomers = async () => {
    try {
      const endpoint = showInactive
        ? `${url}/api/customer/all`
        : `${url}/api/customer`;

      const res = await axios.get(endpoint);
      setCustomers(res.data.data || []);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to fetch customers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, [showInactive]);

  const handleSoftDelete = async (id) => {
    if (window.confirm("Are you sure you want to deactivate this customer?")) {
      try {
        const res = await axios.delete(`${url}/api/customer/${id}`);
        alert(res.data.message || "Customer deactivated successfully");
        fetchCustomers();
      } catch (err) {
        alert(err.response?.data?.message || "Failed to deactivate customer");
      }
    }
  };

  const handleRestore = async (id) => {
    if (window.confirm("Activate this customer?")) {
      try {
        const res = await axios.put(`${url}/api/customer/${id}/restore`);
        alert(res.data.message || "Customer activated successfully");
        fetchCustomers();
      } catch (err) {
        alert(err.response?.data?.message || "Failed to activate customer");
      }
    }
  };

  if (loading) return <div className="loading">Loading customers...</div>;

  return (
    <div className="registration-container">
      <div className="header">
        <h2>Registered Customers</h2>
        <div className="header-actions">
          <button
            onClick={() => setShowInactive(!showInactive)}
            className="toggle-button"
          >
            {showInactive ? 'Show Active Only' : 'Show All'}
          </button>
          <button
            onClick={() => navigate("/registration/new")}
            className="add-button"
          >
            <Plus size={16} /> New Registration
          </button>
        </div>
      </div>

      <table className="registration-table">
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Address</th>
            <th>Registered Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.length === 0 ? (
            <tr>
              <td colSpan="7" className="no-data">
                No customers found
              </td>
            </tr>
          ) : (
            customers.map((customer) => (
              <tr key={customer._id}>
                <td>{customer.fullname}</td>
                <td>{customer.email}</td>
                <td>{customer.phone}</td>
                <td>{customer.address}</td>
                <td>{new Date(customer.createdAt).toLocaleDateString()}</td>
                <td>
                  <span className={`status-badge ${customer.status}`}>
                    {customer.status === "active" ? "Active" : "Inactive"}
                  </span>
                </td>
                <td className="actions">
                  {customer.status === "active" ? (
                    <>
                      <button
                        onClick={() => navigate(`/registration/customer/${customer._id}`)}
                        className="action-btn view"
                        title="View Details"
                      >
                        <Eye size={14} />
                      </button>
                      <button
                        onClick={() => navigate(`/registration/customer/${customer._id}/documents`)}
                        className="action-btn docs"
                        title="View Documents"
                      >
                        <FileText size={14} />
                      </button>
                      <button
                        onClick={() => navigate(`/registration/customer/${customer._id}/jobs`)}
                        className="action-btn jobs"
                        title="View Jobs"
                      >
                        <Briefcase size={14} />
                      </button>
                      <button
                        onClick={() => handleSoftDelete(customer._id)}
                        className="action-btn delete"
                        title="Deactivate"
                      >
                        <Trash2 size={14} />
                      </button>
                    </>
                  ) : (
                    <button
                      onClick={() => handleRestore(customer._id)}
                      className="restore-btn"
                    >
                      <RotateCcw size={14} /> Activate
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerList;